import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46e0e564"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-center h-10 w-full flex items-center relative justify-end",
  style: {"background":"rgba(255, 197, 61, 0.2)","backdrop-filter":"blur(5px)"}
}

import { onMounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  props: {
    duration: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({(e:'close'):void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
duration:number
}

_useCssVars(_ctx => ({
  "147f15a5": (duration.value),
  "44b57082": (startingPoint.value),
  "1d8214f4": (endPoint.value)
}))



const boxInfo = ref<HTMLElement>({} as HTMLElement)
const info = ref<HTMLElement>({} as HTMLElement)
const startingPoint = ref(0)
const endPoint = ref(0)
const duration = ref(props.duration)
const isAnimation = ref(false)
onMounted(async () => {
  // 动画在循环调用时执行起始点， 终点距离是-info的宽度
  info.value.addEventListener('animationiteration', () => {
    startingPoint.value = boxInfo.value.clientWidth + 300
    endPoint.value = -info.value.clientWidth + 100
  })
  // 挂在是否需要动画
  if (info.value.clientWidth > boxInfo.value.clientWidth) {
    startingPoint.value = boxInfo.value.clientWidth + 300
    endPoint.value = -info.value.clientWidth + 100
    isAnimation.value = true
  } else {
    isAnimation.value = false
  }
  // 移动窗口 判断是否需要动画，以及确定终点距离
  window.addEventListener('resize', () => {
    endPoint.value = -info.value.clientWidth
    if (info.value.clientWidth > boxInfo.value.clientWidth) {
      isAnimation.value = true
    } else {
      isAnimation.value = false
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: (_value, _refs) => {
        _refs['boxInfo'] = _value
        boxInfo.value = _value
      },
      class: "relative flex-1 overflow-hidden h-full cursor-pointer flex justify-center items-center infoAnimationBox"
    }, [
      _createElementVNode("div", {
        ref: (_value, _refs) => {
          _refs['info'] = _value
          info.value = _value
        },
        class: _normalizeClass(["whitespace-nowrap absolute leading-5 text-14px", isAnimation.value ? 'infoAnimation' : ''])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 512),
    _createElementVNode("i", {
      class: "el-icon-close cursor-pointer text-xl sm:ml-6 sm:mr-20 mr-10 ml-4",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
    })
  ]))
}
}

})